import React from "react";
import classes from "./blogsListPage.module.css";
import { BlogsFilterPage } from "./blogsFilter/BlogsFilterPage";

import { BlogsTablePage } from "./blogsTable/BlogsTablePage";

export const BlogsListPage = () => {
  return (
    <div className={classes.box}>
      <BlogsFilterPage />
      <BlogsTablePage />
    </div>
  );
};
